import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/warning.png'


const _withScopeId = n => (_pushScopeId("data-v-d2182988"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PendingEventDialog" }
const _hoisted_2 = { class: "PendingEventDialog-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0
}, null, -1))
const _hoisted_4 = { class: "PendingEventDialog-block" }
const _hoisted_5 = { class: "PendingEventDialog-block-hint" }
const _hoisted_6 = { class: "PendingEventDialog-block-cw" }
const _hoisted_7 = {
  key: 0,
  class: "item"
}
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "info" }
const _hoisted_10 = {
  key: 0,
  class: "info-item"
}
const _hoisted_11 = {
  key: 1,
  class: "info-item"
}
const _hoisted_12 = {
  key: 2,
  class: "info-item"
}
const _hoisted_13 = {
  key: 3,
  class: "info-item"
}
const _hoisted_14 = { class: "PendingEventDialog-footer" }
const _hoisted_15 = {
  key: 1,
  class: "PendingEventDialog-logout"
}
const _hoisted_16 = { class: "PendingEventDialog-logout-hint" }
const _hoisted_17 = { class: "PendingEventDialog-logout-btn" }

import { reactive, computed, onMounted } from 'vue'
import { t } from '@/plugins/i18n'
import { useRtfix } from '@/store'
import { useRouter } from 'vue-router'
import { getTotherToken } from '@/apis/user'
import { cancelCustomerVerify, cancelSubCustomerVerify } from '@/apis/login'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: {
  form: {
    type: Object,
    default: null
  }
},
  emits: ['close'],
  setup(__props, { emit: emits }) {

const props = __props
const router = useRouter()

const store = useStore()
const user = computed(() => store.getters.user)

onMounted(() => {
  console.log(user.value)

  cancelVerify()
})



const data: any = reactive({
  show: true,
  // 是否可注销
  isCancal: false,
  // 主账号列表
  mainUserList: [],
  // 店铺列表
  shopList: []
})

// dialog关闭
const handleClose = (obj?: any) => {
  emits('close', obj)
}

const handleEvent = (shopId: any, path: any) => {
  store.commit('route/curShop', shopId)
  router.push(path)
}

// 注销前校验
const cancelVerify = () => {
  const formData = {
    customerId: user.value.customerId
  }
  const api = user.value.accountType === 2 ? cancelSubCustomerVerify : cancelCustomerVerify
  api(formData).then((res: any) => {
    if (res.code === '0') {
      console.log(res)
      if (res.data && res.data.length === 0) {
        data.isCancal = true
      } else {
        data.mainUserList = res.data.filter((item: any) => item.virtualFlag === 1)
        data.shopList = res.data
      }
    }
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(data).show,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).show) = $event)),
    width: 430,
    "before-close": handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_unref(t)('提示')), 1)
        ]),
        (!_unref(data).isCancal)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('您的账号中存在以下未处理完结事件，不能注销。')), 1),
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).mainUserList, (item) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: item.customerId
                    }, [
                      (item.availableAmount)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createTextVNode(_toDisplayString(item.systemSource === 1 ? 'D2C' : 'B2B') + _toDisplayString(_unref(t)('账户余额X元').replace('X', item.availableAmount)) + " ", 1),
                            _createVNode(_component_el_button, {
                              class: "btn underline",
                              type: "text",
                              size: "small",
                              onClick: ($event: any) => (handleClose({ key: 'withdrawal', value: item.systemSource === 1 ? 'd2c' : 'b2b' ,shopInfo: item}))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('提现申请')), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).shopList, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "PendingEventDialog-block-shop",
                    key: item.customerShopId
                  }, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(item.customerShopName), 1),
                    _createElementVNode("div", _hoisted_9, [
                      (item.noCompleteOrderCount && item.noCompleteOrderCount !== '0')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createTextVNode(_toDisplayString(_unref(t)('X笔采购订单').replace('X', item.noCompleteOrderCount)) + " ", 1),
                            _createVNode(_component_el_button, {
                              class: "btn underline",
                              type: "text",
                              size: "small",
                              onClick: ($event: any) => (handleEvent(item.customerShopId, _unref(useRtfix)('OrderList')))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('查看')), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]))
                        : _createCommentVNode("", true),
                      (item.nonDoneRechargeCount && item.nonDoneRechargeCount !== '0')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(t)('X条充值任务未完成').replace('X', item.nonDoneRechargeCount)), 1))
                        : _createCommentVNode("", true),
                      (item.availableAmount && item.availableAmount !== '0')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createTextVNode(_toDisplayString(_unref(t)('账户余额X元').replace('X', item.availableAmount)) + " ", 1),
                            _createVNode(_component_el_button, {
                              class: "btn underline",
                              type: "text",
                              size: "small",
                              onClick: ($event: any) => (handleEvent(item.customerShopId, _unref(useRtfix)('StoreFund')))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('转账')), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]))
                        : _createCommentVNode("", true),
                      (item.productAmount && item.productAmount !== '0')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createTextVNode(_toDisplayString(_unref(t)('库存还有X件商品或辅料').replace('X', item.productAmount)) + " ", 1),
                            _createVNode(_component_el_button, {
                              class: "btn underline",
                              type: "text",
                              size: "small",
                              onClick: ($event: any) => (handleEvent(item.customerShopId, _unref(useRtfix)('stock')))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('去处理')), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_el_button, {
                  class: "btn",
                  type: "primary",
                  onClick: handleClose
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
                  ]),
                  _: 1
                })
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('账号注销后我们将不再保存您的任何账号信息，是否注销？')), 1),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_el_button, {
                  class: "btn",
                  onClick: handleClose
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  class: "btn",
                  type: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClose({ key: 'logoff' })))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('提交')), 1)
                  ]),
                  _: 1
                })
              ])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})